<template>
  <div class="page">
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="formInline" class="card-form demo-form-inline">
            <el-form-item label="工程名称">
              <el-select @change="loadStationList" v-model="selectedProject" value-key="projectId">
                <el-option v-for="p in projectList" :key="p.id" :value="p" :label="p.projectName" />
              </el-select>
            </el-form-item>
            <el-form-item label="测站名称">
              <el-select @change="loadProjectPointList" value-key="projectStationId" v-model="selectedStation">
                <el-option v-for="s in stationList" :key="s.id" :value="s" :label="s.projectStationName">
                  <span style="float: left">{{ s.projectStationName + '(' + s.projectStationId + ')' }}</span>
                  <span v-if="s.online" style="float: right; color: #67C23A; font-size: 13px">在线</span>
                  <span v-else style="float: right; color: #F56C6C; font-size: 13px">离线</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="测点名称">
              <el-input :clearable="true" v-model="formInline.projectPointName" placeholder="测站名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="openAddPointForm">添加测点</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-table border :default-sort="{prop:'projectPointChannel',order:'ascending'}" :data="filterTableData">
            <el-table-column align="center" :sort-method="sortChannle" :sortable="true" prop="projectPointChannel"
              label="测点通道" width="110"></el-table-column>
            <el-table-column align="center" label="是否启用">
              <template slot-scope="scope">{{scope.row.projectPointEnable === "true"?"是":"否"}}</template>
            </el-table-column>
            <el-table-column align="center" label="测站名称/ID" width="150">
              <template slot-scope="scope">{{selectedStation.projectStationName}} /
                {{scope.row.projectStationId}}</template>
            </el-table-column>
            <el-table-column align="center" label="测点名称/ID" width="120">
              <template slot-scope="scope">{{scope.row.projectPointName}} / {{scope.row.projectPointId}}</template>
            </el-table-column>
            <el-table-column align="center" prop="projectPointDeviceType" label="测点类型">
              <template slot-scope="scope">{{showDeviceTypeName(scope.row.projectPointDeviceType)}}</template>
            </el-table-column>
            <el-table-column align="center" label="初始值">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <div style="display:flex" v-for="(f,index) in getPointDeviceInit(scope.row.projectPointDeviceInit)"
                      :key="index">
                      <div style="width:120px;text-align:right;padding-right:5px">{{f.name}}</div>:
                      <div v-if="!f.multiple" style="padding-left:5px">{{f.val}}</div>
                      <div v-if="f.multiple" style="padding-left:5px">{{getMultipleVal(f.val)}}</div>
                    </div>
                  </div>
                  <el-button type="text">查看详情</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="projectPointUnit" label="单位">
              <template slot-scope="scope">{{getUnit(scope.row)}}</template>
            </el-table-column>
            <el-table-column align="center" prop="projectPointUpperLimit" label="上限">
              <template slot-scope="scope">{{getUpper(scope.row)}}</template>
            </el-table-column>
            <el-table-column align="center" prop="projectPointLowerLimit" label="下限">
              <template slot-scope="scope">{{getLower(scope.row)}}</template>
            </el-table-column>
            <el-table-column align="center" :show-overflow-tooltip="true" prop="projectPointPosition" label="位置">
            </el-table-column>
            <el-table-column align="center" :show-overflow-tooltip="true" prop="projectPointComment" label="备注">
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="editPoint(scope.row,scope.$index)" type="text" size="small">编辑</el-button>
                <el-popconfirm style="margin-left:10px" confirm-button-text="确定" cancel-button-text="取消"
                  icon="el-icon-info" icon-color="red" title="确定删除吗"
                  @confirm="deletePointAction(scope.row,scope.$index)">
                  <el-button type="text" size="small" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-drawer :title="this.drawerModel === 'update'?'编辑测点':'添加测点'" :visible.sync="drawer" :direction="direction"
      :before-close="handleClose" class="demo-drawer" size="44%">
      <el-form ref="pointInfo" size="mini" :inline="false" label-width="160px" label-position="right"
        :model="addFormInline" :rules="rules" class="demo-ruleForm">
        <el-form-item label="测站名称" prop="idss">{{selectedStation?selectedStation.projectStationName:"无"}}</el-form-item>
        <el-form-item label="测点通道" prop="projectPointChannel">
          <el-input @change="checkBatteryChannel" type="number" v-model="addFormInline.projectPointChannel"
            style="width:10vw;margin:0 5px" placeholder="测点通道"></el-input>是否启用:
          <el-select v-model="addFormInline.projectPointEnable" placeholder="是否启用">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="测点名称" prop="projectPointName">
          <el-input style="width:85%" v-model="addFormInline.projectPointName" placeholder="测点名称"></el-input>
        </el-form-item>
        <el-form-item label="测点ID" prop="projectPointId">
          <el-input :disabled="disablePointIdState" style="width:85%;margin-right:5px" @change="toUpperPointId"
            v-model="addFormInline.projectPointId" placeholder="输入传感器的ID号"></el-input>
          <el-button v-show="this.drawerModel === 'update'" type="text" @click="modifyPointId">修改</el-button>
        </el-form-item>

        <el-form-item label="测点类型" prop="projectPointDeviceType">
          <el-select style="width:85%" v-model="addFormInline.projectPointDeviceType" value-key="val"
            @change="changFormula" placeholder="测点类型">
            <el-option v-for="(f,index) in formulaList" :label="f.name" :value="f.val" :key="'fff_'+index" />
          </el-select>
          <el-popover placement="right" width="310" trigger="click">
            <el-row>
              <el-col>
                <img width="300" :src="formulaPicUrl" />
              </el-col>
            </el-row>
            <i slot="reference" class="el-icon-question el-icon--right">公式</i>
          </el-popover>
        </el-form-item>
        <el-divider class="c-divider" content-position="center">测点参数</el-divider>
        <div class="c-form">
          <template v-if="addFormInline.projectPointDeviceInit">
            <el-row v-if="selectedDevice.customization" style="margin-bottom:0.8em">
              <el-col style="text-align:center" :offset="6" :span="8">
                <el-tag>{{selectedDevice.title[0]}}</el-tag>
              </el-col>
              <el-col style="text-align:center" :offset="2" :span="8">
                <el-tag>{{selectedDevice.title[1]}}</el-tag>
              </el-col>
            </el-row>
            <el-form-item class="s-item is-required" :label="ext.name"
              v-for="(ext,index) in addFormInline.projectPointDeviceInit" :key="ext.name+index">
              <el-input v-if="!ext.multiple" v-model="ext.val" style="width:100%;margin:0 0">
                <div style="width:60px" slot="append">{{ext.unit}}</div>
              </el-input>
              <template v-if="ext.multiple">
                <div style="display:flex;justify-content: space-between">
                  <el-input v-for="(item, index) in ext.val" :key="ext.key+index" v-model="ext.val[index].val"
                    :class="ext.val.length==2?'two-input':'three-input'">
                  </el-input>
                </div>
              </template>
            </el-form-item>
          </template>
          <el-form-item v-if="!selectedDevice.hiddenUnit" label="单位" prop="projectPointUnit">
            <el-select allow-create filterable style="width:100%" v-model="addFormInline.projectPointUnit"
              placeholder="单位">
              <el-option v-for="u in unitList" :key="u.name" :value="u.val" :label="u.name" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="!selectedDevice.hiddenLimit" label="上限" prop="projectPointUpperLimit">
            <el-input type="number" v-model="addFormInline.projectPointUpperLimit" placeholder="上限"></el-input>
          </el-form-item>
          <el-form-item v-if="!selectedDevice.hiddenLimit" label="下限" prop="projectPointLowerLimit">
            <el-input type="number" v-model="addFormInline.projectPointLowerLimit" placeholder="下限"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="位置">
          <el-input v-model="addFormInline.projectPointPosition" placeholder="位置"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入备注信息"
            v-model="addFormInline.projectPointComment"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :disabled="onSubmiting" @click="submitPoint">保存</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
import { RULES, UNITS, FORMULA_LIST } from "./pointPage";
import { listStation } from "@/api/stationApi";
import { listProject } from "@/api/projectApi";
import { listPoint, addPoint, updatePoint, deletePoint } from "@/api/pointApi";
export default {
  mounted() {
    const sid = this.$route.query.stationId;
    const sName = this.$route.query.stationName;
    const pId = this.$route.query.projectId;
    if (sid) {
      this.formInline.stationId = sid;
      this.stationInfo.stationId = sid;
      this.stationInfo.stationName = sName;
      this.selectedProject = {
        projectId: pId
      };
      this.selectedStation = {
        projectStationId: sid,
        projectStationName: sName
      };
    }
    this.loadProjectList();
    this.loadStationList();
    this.loadProjectPointList();
  },
  data() {
    return {
      selectedProject: undefined,
      selectedStation: undefined,
      selectedDevice: {},
      stationList: [],
      projectList: [],
      drawerModel: "",
      rules: RULES,
      unitList: UNITS,
      pointList: [],
      stationInfo: {},
      formInline: {
        projectPointName: ""
      },
      addFormInline: {},
      drawer: false,
      direction: "rtl",
      formulaList: FORMULA_LIST,
      formulaPicUrl: "",
      onSubmiting: false,
      disablePointIdState: true
    };
  },
  methods: {
    modifyPointId() {
      this.$confirm("修改「测点ID」选项必须到「测站管理」中手动下发配置,否则「测点ID」将不生效！", "提示", {
        confirmButtonText: "我已阅读且知晓其含义",
        cancelButtonText: "放弃修改",
        type: "warning"
      }).then(() => {
        this.disablePointIdState = false;
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消修改"
        });
      });
    },
    changFormula(selected) {
      console.log("selected", selected);
      this.selectedDevice = this.formulaList.find(
        v => v.val === selected
      );
      this.addFormInline.projectPointDeviceInit = this.selectedDevice.ext;
      this.formulaPicUrl = this.selectedDevice.url;
      if (this.selectedDevice.customization && this.selectedDevice.hiddenLimit) {
        this.$set(this.addFormInline, "projectPointUpperLimit", "9999");
        this.$set(this.addFormInline, "projectPointLowerLimit", "-9999");
      } else {
        this.$set(this.addFormInline, "projectPointUpperLimit", "");
        this.$set(this.addFormInline, "projectPointLowerLimit", "");
      }
      if (this.selectedDevice.customization && this.selectedDevice.hiddenUnit) {
        this.$set(this.addFormInline, "projectPointUnit", "");
      } else {
        this.$set(this.addFormInline, "projectPointUnit", "");
      }
      this.checkBatteryChannel();
    },
    checkBatteryChannel() {
      const channel = this.addFormInline.projectPointChannel;
      const type = this.addFormInline.projectPointDeviceType;
      const notBattery =
        (channel === "0" && type !== "battery") ||
        (channel !== "0" && type === "battery");
      if (notBattery) {
        this.$message.error("0号通道必须是电池,请检查配置");
      }

      const chVal = parseInt(channel);
      const chStationChCount = parseInt(this.selectedStation.projectStationChannelCount);
      if (chVal > chStationChCount) {
        this.$message.error("该测站的最大通道数为" + chStationChCount + ",不能超过此数");
      }
    },
    onSubmit() {
      this.$message.success("查询成功");
    },
    openAddPointForm() {
      if (!this.selectedStation) {
        this.$message.error("请选择一个测站后再添加");
        return;
      }
      let max = "-1";
      if (this.pointList) {
        max = this.pointList.reduce((x, y) => {
          const pointX = parseInt(x) || 0;
          const pointY = parseInt(y.projectPointChannel);
          const res = pointX > pointY ? pointX : pointY;
          console.log(x, y, pointX, pointY, res);
          return res;
        }, 0);
      }
      // this.$message.info(`max is :${max}`);
      if (!this.addFormInline.projectPointChannel) {
        this.$set(this.addFormInline, "projectPointChannel", parseInt(max) + 1);
      }

      this.drawer = true;
      this.drawerModel = "";
      this.formulaPicUrl = "";
      this.disablePointIdState = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          this.addFormInline = {};
          this.disablePointIdState = true;
          done();
        })
        .catch(_ => { });
    },
    submitPoint() {
      this.$refs.pointInfo.validate(valid => {
        if (valid) {
          if (!this.addFormInline.projectPointEnable) {
            this.$message.error("是否启用为必选项");
            return;
          }
          if (this.checkUpper()) {
            this.$message.error("下限值不能大于上限值");
            return;
          }
          const chVal = parseInt(this.addFormInline.projectPointChannel);
          const chStationChCount = parseInt(this.selectedStation.projectStationChannelCount);
          if (chVal > chStationChCount) {
            this.$message.error("该测站的最大通道数为" + chStationChCount + ",不能超过此数");
            return;
          }
          this.onSubmiting = true;
          this.addFormInline.projectPointDeviceInit = JSON.stringify(
            this.addFormInline.projectPointDeviceInit
          );
          if (this.drawerModel === "update") {
            this.drawerModel = "";
            this.updateIndex = -1;
            updatePoint(this.addFormInline).then(res => {
              const resp = res.data;
              if (resp.code === 200) {
                this.$message.success("更新成功");
                this.loadProjectPointList();
              } else {
                this.$message.error(resp.msg);
              }
              this.drawer = false;
              this.onSubmiting = false;
              this.addFormInline = {};
            });
          } else {
            this.$confirm("新增测点必须到「测站管理」中手动下发配置,否则「测点ID」将不生效！", "提示", {
              confirmButtonText: "我已阅读且知晓其含义",
              cancelButtonText: "取消保存",
              type: "warning"
            }).then(() => {
              this.addFormInline.projectId = this.selectedProject.projectId;
              this.addFormInline.projectStationId = this.selectedStation.projectStationId;
              addPoint(this.addFormInline).then(res => {
                this.onSubmiting = false;
                const resp = res.data;
                if (resp.code === 200) {
                  this.$message.success("添加成功");
                  this.loadProjectPointList();
                } else {
                  this.$message.error(resp.msg);
                }
              });
              this.addFormInline = {};
              this.drawer = false;
            }).catch(() => {
              this.addFormInline = {};
              this.drawer = false;
              this.onSubmiting = false;
              this.$message({
                type: "info",
                message: "已取消保存"
              });
            });
          }
        }
      });
    },
    editPoint(row, index) {
      this.drawerModel = "update";
      this.disablePointIdState = true;
      this.updateIndex = index;
      this.addFormInline = JSON.parse(JSON.stringify(row));
      this.addFormInline.projectPointDeviceInit = JSON.parse(
        this.addFormInline.projectPointDeviceInit
      );
      this.selectedDevice = this.formulaList.find(
        v => v.val === row.projectPointDeviceType
      );
      this.formulaPicUrl = this.selectedDevice.url;
      this.drawer = true;
    },
    deletePointAction(row, index) {
      deletePoint(row).then(res => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.loadProjectPointList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    toUpperPointId() {
      if (!this.addFormInline.projectPointId.startsWith("Bat")) {
        this.addFormInline.projectPointId = this.addFormInline.projectPointId.toUpperCase();
        const dumplicatId = this.pointList.find(v => v.projectPointId === this.addFormInline.projectPointId);
        if (dumplicatId !== undefined) {
          this.$message.error("测点ID:" + this.addFormInline.projectPointId + " 在当前测站中已经存在");
        }
      }
    },
    loadProjectList() {
      listProject({}).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.projectList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    loadStationList(v) {
      if (!this.selectedProject) {
        return;
      }
      this.pointList = [];
      listStation({ projectId: this.selectedProject.projectId }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.stationList = resp.content;
          if (this.selectedStation && this.selectedStation.projectStationId) {
            this.selectedStation = this.stationList.find(s => s.projectStationId === this.selectedStation.projectStationId);
          }
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    loadProjectPointList() {
      if (!this.selectedProject) {
        return;
      }
      if (!this.selectedStation) {
        return;
      }
      listPoint({
        projectId: this.selectedProject.projectId,
        projectStationId: this.selectedStation.projectStationId
      }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.pointList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    getPointDeviceInit(v) {
      return JSON.parse(v);
    },
    showDeviceTypeName(type) {
      const device = this.formulaList.find(v => v.val === type);
      return device ? device.name : type === "battery" ? "电池" : type;
    },
    getMultipleVal(val) {
      return val.map(v => v.val).join(", ");
    },
    sortChannle(a, b) {
      const n1 = parseInt(a.projectPointChannel);
      const n2 = parseInt(b.projectPointChannel);
      return n1 - n2;
    },
    checkUpper() {
      const upper = parseFloat(this.addFormInline.projectPointUpperLimit) || 0;
      const lower = parseFloat(this.addFormInline.projectPointLowerLimit) || 0;
      return lower > upper;
    },
    getUpper(row) {
      const selectedDevice = this.formulaList.find(
        v => v.val === row.projectPointDeviceType
      );
      if (selectedDevice.hiddenLimit) {
        const config = this.getPointDeviceInit(row.projectPointDeviceInit);
        const upper = config.find(v => v.key === "upper");
        return upper.val.map(u => u.val).join(", ");
      } else {
        return row.projectPointUpperLimit;
      }
    },
    getLower(row) {
      const selectedDevice = this.formulaList.find(
        v => v.val === row.projectPointDeviceType
      );
      if (selectedDevice.hiddenLimit) {
        const config = this.getPointDeviceInit(row.projectPointDeviceInit);
        const lower = config.find(v => v.key === "lower");
        return lower.val.map(u => u.val).join(", ");
      } else {
        return row.projectPointLowerLimit;
      }
    },
    getUnit(row) {
      const selectedDevice = this.formulaList.find(
        v => v.val === row.projectPointDeviceType
      );
      if (selectedDevice.hiddenUnit) {
        const config = this.getPointDeviceInit(row.projectPointDeviceInit);
        const lower = config.find(v => v.key === "unit");
        return lower.val.map(u => u.val).join(", ");
      } else {
        return row.projectPointUnit;
      }
    }
  },
  computed: {
    filterTableData() {
      let data = this.pointList;
      if (this.formInline.projectPointName) {
        data = data.filter(
          v => v.projectPointName === this.formInline.projectPointName
        );
      }
      return data;
    }
  }
};
</script>
<style scoped>
.page {
  margin-top: 14px;
}
.demo-ruleForm {
  width: calc(100% - 10px);
}
.s-item .el-form-item__label {
  color: #f50100;
}
.card-basic {
  margin: 5px 10px;
}
.card-form .el-form-item {
  margin-bottom: 0px;
}
.c-form {
  border: 1px solid #dcdfe6;
  padding: 15px 10px 10px 0px;
  margin-left: 5px;
  margin-bottom: 15px;
}
.c-divider {
  margin: 0px !important;
  height: 0px;
  color: red;
}
.two-input {
  width: 14vw;
}
.three-input {
  width: 9vw;
}
</style>
